const toYm = (d: Date) =>
  `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;

const shiftMonth = (date: Date, months: number) =>
  new Date(date.getFullYear(), date.getMonth() + months, 1);

/**
 * 오늘 올리면 들어갈 등록월 · 정산월 (yyyyMM) — 서버 10일 마감 규칙과 같다.
 *   1~10일 → 등록월 이번 달 · 정산월 다음 달
 *   11일~말일 → 등록월 다음 달 · 정산월 2달 뒤
 *
 * 년월은 서버가 정하고 업로드 완료 응답(settlementYearMonth 등)으로 돌려준다.
 * 이 값은 업로드 전 안내 · 등록 현황의 「현재 등록월」 표시에만 쓰고, 완료 뒤에는 응답 값을 쓴다.
 */
export const getUploadRegistrationYearMonth = (date: Date = new Date()) =>
  toYm(shiftMonth(date, date.getDate() <= 10 ? 0 : 1));

export const getUploadSettlementYearMonth = (date: Date = new Date()) =>
  toYm(shiftMonth(date, date.getDate() <= 10 ? 1 : 2));
